import { array, Decoder, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../Resource/Decoders';
import { Resource } from '../../../../Resource/Types';

// Base competency type
export interface PopularCompetencyPayload {
  name: string;
  enrollments: number;
}

// Collection of competencies wrapped in a resource
export type PopularCompetenciesResource = Resource<PopularCompetencyPayload[]>;

// Decoders
const popularCompetencyPayloadDecoder: Decoder<PopularCompetencyPayload> = succeed({})
  .assign('name', field('name', string))
  .assign('enrollments', field('enrollments', number));

export const popularCompetenciesResourceDecoder: Decoder<PopularCompetenciesResource> =
  resourceDecoder(array(popularCompetencyPayloadDecoder));
